import { NgModule } from '@angular/core';
import { HighlighterDirective } from './highlighter.directive';

@NgModule({
    declarations: [
        HighlighterDirective
    ],
    imports: [],
    exports: [
        HighlighterDirective
    ]
})
export class NcHighlighterModule { }